import { ProviderComposer } from "@design-lab/shared";
import { DtfChannelProvider } from "@design-lab/shared/hooks/useDtfChannel";
import { TransfersArtworksFormProvider } from "@design-lab/entities/transfers";
import { TransfersLabPage } from "@design-lab/pages/transfers-lab";
import { ArtworkFormProvider, ArtworkProvider } from "@design-lab/entities/artwork";
import { CompositionFormProvider } from "@design-lab/entities/composition";
import { ValidationProvider } from "@design-lab/app/providers/ValidationProvider";

export function TransfersLabRoute() {
  const providers = [
    DtfChannelProvider,
    TransfersArtworksFormProvider,
    CompositionFormProvider,
    ArtworkFormProvider,
    ArtworkProvider,
    ValidationProvider
  ];

  return (
    <ProviderComposer providers={providers}>
      <TransfersLabPage />
    </ProviderComposer>
  );
}
